import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './components/ui/card';
import { Button } from './components/ui/button';
import { ImageIcon, Key, FileText, ArrowLeft } from 'lucide-react';
import ImageProcessor from './components/ImageProcessor';
import PasswordGeneratorTool from './components/PasswordGeneratorTool';
import MarkdownConverterTool from './components/MarkdownConverterTool';

function App() {
  const [currentTool, setCurrentTool] = useState<string | null>(null);

  if (currentTool === 'image-processor') {
    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="mb-6">
            <Button
              variant="outline"
              onClick={() => setCurrentTool(null)}
              className="mb-4"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              返回工具门户
            </Button>
          </div>
          <ImageProcessor />
        </div>
      </div>
    );
  }

  if (currentTool === 'password-generator') {
    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="mb-6">
            <Button
              variant="outline"
              onClick={() => setCurrentTool(null)}
              className="mb-4"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              返回工具门户
            </Button>
          </div>
          <PasswordGeneratorTool />
        </div>
      </div>
    );
  }

  if (currentTool === 'markdown-converter') {
    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="mb-6">
            <Button
              variant="outline"
              onClick={() => setCurrentTool(null)}
              className="mb-4"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              返回工具门户
            </Button>
          </div>
          <MarkdownConverterTool />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-foreground mb-2">工具门户</h1>
          <p className="text-muted-foreground">一个可扩展的工具应用平台</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card className="hover:shadow-lg transition-shadow cursor-pointer">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <ImageIcon className="w-5 h-5" />
                图片处理工具
              </CardTitle>
              <CardDescription>
                图片压缩、格式转换等多种处理功能
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button
                className="w-full"
                onClick={() => setCurrentTool('image-processor')}
              >
                打开工具
              </Button>
            </CardContent>
          </Card>

          <Card className="hover:shadow-lg transition-shadow cursor-pointer">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Key className="w-5 h-5" />
                密码生成器
              </CardTitle>
              <CardDescription>
                生成安全可靠的密码，支持多种设置
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button
                className="w-full"
                onClick={() => setCurrentTool('password-generator')}
              >
                打开工具
              </Button>
            </CardContent>
          </Card>

          <Card className="hover:shadow-lg transition-shadow cursor-pointer">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="w-5 h-5" />
                Markdown转Word
              </CardTitle>
              <CardDescription>
                将Markdown文档转换为Word格式，支持数学公式
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button
                className="w-full"
                onClick={() => setCurrentTool('markdown-converter')}
              >
                打开工具
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default App;